<template>
    <div class="l-propertylisting">

        <section class="m-tabs">
            <div class="container">
                <ul class="nav-tabs e-tabs" id="myTab" role="tablist">
                    <li :class="['nav-item', { active : !hasFilter }]">
                        <a :class="['nav-link', { active : !hasFilter }]" id="locations-tab" data-toggle="tab" href="#locationsTab" role="tab"
                           aria-controls="home" aria-selected="true">Locations</a>
                    </li>
                    <li :class="['nav-item', { active : hasFilter }]">
                        <a :class="['nav-item', { active : hasFilter }]" id="list-tab" data-toggle="tab" href="#listTab" role="tab"
                           aria-controls="home" aria-selected="true">List view</a>
                    </li>
                    <li class="nav-item" v-if="mapViewUrl">
                        <a class="nav-link" id="map-tab" :href="mapViewUrl + '?' + filterQuerystring"
                           aria-controls="home" aria-selected="true">Map view</a>
                    </li>
                  <!--<li class="align-right" v-if="isLoggedIn">
                    <a href="#" class="property-alerts">Property alerts</a>
                  </li>-->
                </ul>
            </div>
        </section>

        <div class="tab-content result-tabs" id="contactTabContent">
            <div :class="['tab-pane', { active : !hasFilter }]" id="locationsTab" role="tabpanel"
                 aria-labelledby="mainContacts-tab">
                <regions-list></regions-list>
            </div>

            <div :class="['tab-pane', { active : hasFilter }]" id="listTab" role="tabpanel"
                 aria-labelledby="mainContacts-tab">
                <properties-list></properties-list>
            </div>
        </div>
    </div>

</template>

<script>
    // import $ from 'jquery'
    import PropertiesList from '@/components/SiteSearch/search-list'
    import RegionsList from '@/components/PropertySearch/regions-list'

    import { globalMixin } from '@/mixins/globalMixin.js'

    export default {
        components: {
            PropertiesList,
            RegionsList
        },

        computed: {
            currentTab: {
                get() {
                    return this.$store.state.propertiesSearch.currentTab
                },
                set(newValue) {
                    this.$store.dispatch('updatePropertiesSearchCurrentTab', newValue)
                }
            },

            filterQuerystring: function () {
                return this.$store.getters.searchFiltersQuerystring()
            },

            hasFilter: function () {
                return this.$store.state.search.hasFilter
            },

            isLoggedIn: function () {
                return isLoggedIn
            }
        },

        created: function () {
            this.$eventHub.$on('search-regionSelected', this.OnRegionSelected)
        },

        data() {
            return {
                loading: false,
                tabs: [
                    {
                        id: 'regions-list',
                        label: 'Locations'
                    },
                    {
                        id: 'properties-list',
                        label: 'List view'
                    }
                ]
            }
        },

        methods: {
            OnRegionSelected: function () {
                this.currentTab = 'properties-list'
            }
        },

        mixins: [globalMixin],

        props: {
            mapViewUrl: String
        }
    }
</script>